import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const SUMMARIES_BASE_PATH = `${MIDDLE_OFFICE_BASE_PATH}/summaries`;
